import { render, staticRenderFns } from "./collapse.transition-group.component.vue?vue&type=template&id=e90cb0e8"
import script from "./collapse.transition-group.component.vue?vue&type=script&lang=js"
export * from "./collapse.transition-group.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports